import { COUNT_ITEM } from '@doltech/ui/lib/figma/DolEditor/elements/sentences-count/renderElement';
import { useDeviceDetect } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';
import { ExplanationTypeEnum } from '@doltech/utils/lib/constants';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { ParaphrasingViewOnlyComponent } from '../../../paraphrasing/ParaphrasingViewOnly';

export const ParaphrasingWrapper = styled.div`
  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const Main = styled.section``;

export interface ExplanationSummaryAndDetailProps {
  no?: number;
  explanation?: any;
  showTitle?: boolean;
}

export const SingleChoiceExplanationSummaryAndDetail = observer(
  (props: ExplanationSummaryAndDetailProps) => {
    const { explanation, showTitle } = props;

    const getTitle = () => {
      if (explanation.type === ExplanationTypeEnum.MAIN_IDEA) {
        return 'Simplify & Connection';
      }
      return 'Paraphrasing';
    };
    const getInitValue = () => {
      if (explanation.type === ExplanationTypeEnum.MAIN_IDEA) {
        return explanation?.simplify;
      }
      return explanation?.paraphrasing;
    };

    const getValueForMobile = (data) => {
      const result = [];
      JSON.parse(data).forEach((item) => {
        item.children.forEach((it) => {
          if (it.type !== COUNT_ITEM) result.push(it);
        });
      });
      return result;
    };

    const { isMobile } = useDeviceDetect();

    return (
      <Main>
        {isMobile && explanation?.locatedPassage && (
          <ParaphrasingWrapper>
            <ParaphrasingViewOnlyComponent
              className="explanation-detail-section"
              title="Located Paragraph"
              initValue={getValueForMobile(explanation?.locatedPassage)}
              showTitle={showTitle}
            />
          </ParaphrasingWrapper>
        )}
        <ParaphrasingWrapper>
          {ExplanationTypeEnum.LISTENING_EXPLANATION !== explanation?.type &&
            explanation?.locatedPassage && (
              <ParaphrasingViewOnlyComponent
                title={getTitle()}
                initValue={getInitValue()}
                showTitle={showTitle}
              />
            )}
        </ParaphrasingWrapper>
        <ParaphrasingWrapper>
          <ParaphrasingViewOnlyComponent
            title="Giải thích chi tiết"
            initValue={explanation?.detailExplanation}
            showTitle={showTitle}
          />
        </ParaphrasingWrapper>
      </Main>
    );
  }
);
